import React from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './FormErrors.mod.css';

const cn = classnames.bind(styles);

const FormErrors = ({ errors }) =>
  Array.isArray(errors) ? (
    <div className={cn('container')}>
      {Array.isArray(errors) &&
        errors.map((error, idx) => (
          <p className={styles.error} key={idx}>
            {error}
          </p>
        ))}
    </div>
  ) : null;

FormErrors.propTypes = {
  errors: T.oneOfType([T.array, T.object])
};

export default FormErrors;



// WEBPACK FOOTER //
// ./src/components/Form/FormErrors.jsx